export default "__VITE_ASSET__Erl9pNW2__"